export const COLOR_ROLE_LABELS = Object.freeze({
  base: "Основа",
  primary: "Основной цвет",
  accent: "Акцентный цвет",
  support: "Поддерживающий цвет",
  "dark-text": "Цвет текста",
  neutral: "Нейтральный цвет",
});

export function hexToRgb(hex) {
  const canonical = /^#[0-9A-F]{6}$/.test(hex || "") ? hex : "#000000";
  return {
    r: Number.parseInt(canonical.slice(1, 3), 16),
    g: Number.parseInt(canonical.slice(3, 5), 16),
    b: Number.parseInt(canonical.slice(5, 7), 16),
  };
}

export function rgbLabel(hex) {
  const { r, g, b } = hexToRgb(hex);
  return `RGB ${r}, ${g}, ${b}`;
}

export function approximateCmyk(hex) {
  const { r, g, b } = hexToRgb(hex);
  const maximum = Math.max(r, g, b);
  if (maximum === 0) return "CMYK 0, 0, 0, 100";
  // Integer-channel form avoids cancelling nearly equal floating values
  // before rounding half percentages (e.g. 42.5 becoming 42.499999...).
  const k = (255 - maximum) / 255;
  const c = (maximum - r) / maximum;
  const m = (maximum - g) / maximum;
  const y = (maximum - b) / maximum;
  return `CMYK ${Math.round(c * 100)}, ${Math.round(m * 100)}, ${Math.round(y * 100)}, ${Math.round(k * 100)}`;
}

const linear = (channel) => {
  const value = channel / 255;
  return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
};

export function contrastRatio(backgroundHex, textHex) {
  const bg = hexToRgb(backgroundHex); const text = hexToRgb(textHex);
  const luminance = (value) => 0.2126 * linear(value.r) + 0.7152 * linear(value.g) + 0.0722 * linear(value.b);
  const first = luminance(bg); const second = luminance(text);
  return (Math.max(first, second) + 0.05) / (Math.min(first, second) + 0.05);
}

export function contrastPresentation(backgroundHex, textHex) {
  const ratio = contrastRatio(backgroundHex, textHex);
  if (ratio >= 4.5) return { ratio, label: "Подходит для текста" };
  if (ratio >= 3) return { ratio, label: "Только для крупных элементов" };
  return { ratio, label: "Не использовать для текста" };
}

export function colorHue(hex) {
  const { r, g, b } = hexToRgb(hex);
  const rr = r / 255; const gg = g / 255; const bb = b / 255;
  const max = Math.max(rr, gg, bb); const min = Math.min(rr, gg, bb);
  if (max === min) return 0;
  const delta = max - min;
  const value = max === rr ? ((gg - bb) / delta) % 6 : max === gg ? (bb - rr) / delta + 2 : (rr - gg) / delta + 4;
  return (value * 60 + 360) % 360;
}
